import React from 'react'

const Social = () => {
    return (
        <div className="home_social">
            
            <a href="https://www.linkedin.com/in/leelakrishnasai" className="home_social-icon" target="_blank" rel="noopener noreferrer">
                <i class="uil uil-linkedin"></i>
            </a>

            <a href="https://github.com/leelakrishnasainaidu" className="home_social-icon" target="_blank" rel="noopener noreferrer">
                <i class="uil uil-github-alt"></i>
            </a>

            <a href="https://www.instagram.com/lks_edits_" className="home_social-icon" target="_blank" rel="noopener noreferrer">
                <i class="uil uil-instagram"></i>
            </a>
        </div>
    )
}

export default Social